import { type FC } from "react";
import type { Certificate } from "../../../shared/models/certificate";

export const RevokeCertificateModal: FC<{
  certificate: Certificate;
  isRevoking: boolean;
  error?: string;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
}> = ({ certificate, isRevoking, error, onClose, onConfirm }) => {
  return (
    <div className="vmx-modal" style={{ maxWidth: 420 }}>
      <div className="vmx-modal-header">
        <div className="vmx-modal-title">Revoke Certificate</div>
      </div>
      <div className="vmx-modal-body">
        <p style={{ color: "var(--vmx-gray-600)", lineHeight: 1.6 }}>
          Are you sure you want to revoke certificate{" "}
          <strong>{certificate.deviceId}</strong>? The certificate will be
          marked as revoked immediately.
        </p>
        {error !== undefined && (
          <div
            style={{
              marginTop: 12,
              fontSize: "0.8125rem",
              color: "var(--vmx-danger)",
            }}
          >
            {error}
          </div>
        )}
      </div>
      <div className="vmx-modal-footer">
        <button
          className="vmx-btn vmx-btn-secondary"
          onClick={onClose}
          disabled={isRevoking}
        >
          Cancel
        </button>
        <button
          className="vmx-btn vmx-btn-danger"
          onClick={onConfirm}
          disabled={isRevoking}
        >
          {isRevoking ? "Revoking..." : "Revoke"}
        </button>
      </div>
    </div>
  );
};
